import { GraphQLObjectType, GraphQLInputObjectType } from 'graphql';
import { FieldsExtractor, SystemFieldsExcluder } from './types';

export default class GraphQLFieldsExtractor implements FieldsExtractor {
  constructor(
    private fieldsExcluder: SystemFieldsExcluder,
  ) {}

  extractFrom(type: unknown) {
    if (!(type instanceof GraphQLObjectType || type instanceof GraphQLInputObjectType)) return [];

    const fields = Object.values(type.getFields());
    return this.fieldsExcluder.excludeSystemFieldsFrom(fields);
  }
}
